var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDivider2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 1200 200",
    width: 1200,
    height: 200,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 76L13.3 85.7C26.7 95.3 53.3 114.7 80 118.3C106.7 122 133.3 110 160 101C186.7 92 213.3 86 240 80.3C266.7 74.7 293.3 69.3 320 75.2C346.7 81 373.3 98 400 110.2C426.7 122.3 453.3 129.7 480 131C506.7 132.3 533.3 127.7 560 114.5C586.7 101.3 613.3 79.7 640 73.3C666.7 67 693.3 76 720 85C746.7 94 773.3 103 800 103.2C826.7 103.3 853.3 94.7 880 87C906.7 79.3 933.3 72.7 960 77.8C986.7 83 1013.3 100 1040 97.8C1066.7 95.7 1093.3 74.3 1120 72.8C1146.7 71.3 1173.3 89.7 1186.7 98.8L1200 108L1200 0L1186.7 0C1173.3 0 1146.7 0 1120 0C1093.3 0 1066.7 0 1040 0C1013.3 0 986.7 0 960 0C933.3 0 906.7 0 880 0C853.3 0 826.7 0 800 0C773.3 0 746.7 0 720 0C693.3 0 666.7 0 640 0C613.3 0 586.7 0 560 0C533.3 0 506.7 0 480 0C453.3 0 426.7 0 400 0C373.3 0 346.7 0 320 0C293.3 0 266.7 0 240 0C213.3 0 186.7 0 160 0C133.3 0 106.7 0 80 0C53.3 0 26.7 0 13.3 0L0 0Z",
    fill: "#fffdf5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivider2);
export default __webpack_public_path__ + "static/media/divider2.3568dac96d994849b03e07edd94365f5.svg";
export { ForwardRef as ReactComponent };